/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I convert percent to molarity?`)
};

const es_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo convierto porcentaje a molaridad?`)
};

const de_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie rechne ich Prozent in Molarität um?`)
};

const nl_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe reken ik percentage om naar molariteit?`)
};

const fr_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment convertir le pourcentage en molarité ?`)
};

const it_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come converto la percentuale in molarità?`)
};

const pt_br2_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como converto percentual para molaridade?`)
};

const pt_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como converto percentagem em molaridade?`)
};

const ja_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセントをモル濃度に変換するには？`)
};

const zh_pctsol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何将百分比换算为摩尔浓度？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_faq_q4", locale)
	if (locale === "en") return en_pctsol_faq_q4(inputs)
	if (locale === "es") return es_pctsol_faq_q4(inputs)
	if (locale === "de") return de_pctsol_faq_q4(inputs)
	if (locale === "nl") return nl_pctsol_faq_q4(inputs)
	if (locale === "fr") return fr_pctsol_faq_q4(inputs)
	if (locale === "it") return it_pctsol_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_faq_q4(inputs)
	if (locale === "pt") return pt_pctsol_faq_q4(inputs)
	if (locale === "ja") return ja_pctsol_faq_q4(inputs)
	return zh_pctsol_faq_q4(inputs)
};